// src/shared/components/StravaBadge/index.js
import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const StravaLogo = () => (
    <svg viewBox="0 0 24 24" width="13" height="13" fill="white" aria-hidden="true" style={{ flexShrink: 0 }}>
        <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169" />
    </svg>
);

const StravaBadge = ({ stravaActivityId }) => {
    const Tag = stravaActivityId ? 'a' : 'span';
    const linkProps = stravaActivityId
        ? {
              href: `https://www.strava.com/activities/${stravaActivityId}`,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {};

    return (
        <Tag className="strava-badge" {...linkProps}>
            <StravaLogo />
            Strava
        </Tag>
    );
};

StravaBadge.propTypes = {
    stravaActivityId: PropTypes.string,
};

export default StravaBadge;
